import { horizontalListSortingStrategy, SortableContext } from "@dnd-kit/sortable";

import SkeletonHeaderRow from "@/components/atoms/table/SkeletonHeaderRow";
import TableHeaderRow, { TableHeaderRowProps } from "@/components/molecules/table/TableHeaderRow";
import { VirtualTableProps } from "@/components/organisms/table/table.utils";

type TableHeadProps<T extends { id: string }> = {
  isLoading: boolean;
  showHeaderWhileLoading: boolean;
  columnVisibility: Record<string, boolean>;
} & VirtualTableProps<T> &
  Omit<TableHeaderRowProps<T>, "headerGroup">;

const TableHead = <T extends { id: string }>({
  table,
  columnVirtualizer,
  columnVisibility,
  canReorderColumns,
  virtualPaddings,
  isLoading,
  showHeaderWhileLoading,
}: TableHeadProps<T>) => {
  return (
    <thead className={"sticky top-0 z-20 grid"}>
      <SortableContext
        items={canReorderColumns ? Object.keys(columnVisibility).map((columnId) => `column-${columnId}`) : []}
        strategy={horizontalListSortingStrategy}
      >
        {table.getHeaderGroups().map((headerGroup, index) => {
          if (isLoading && !showHeaderWhileLoading) {
            return <SkeletonHeaderRow headerGroup={headerGroup} key={index} />;
          }

          return (
            <TableHeaderRow
              key={headerGroup.id}
              headerGroup={headerGroup}
              canReorderColumns={canReorderColumns}
              columnVirtualizer={columnVirtualizer}
              virtualPaddings={virtualPaddings}
            />
          );
        })}
      </SortableContext>
    </thead>
  );
};

export default TableHead;
